export default "__VITE_ASSET__D1l64xcL__"